import { Section, LatexFormula, renderRich } from "./shared";

export function WorkedExamplesSection({ examples, regex }) {
  if (!examples?.length) return null;
  return (
    <Section label="Worked Examples">
      <div className="space-y-4">
        {examples.map((ex, i) => (
          <div key={i} className="border border-black/15 bg-white p-3 text-sm">
            <p className="font-heading font-bold">Problem {i + 1}. {renderRich(ex.problem, regex)}</p>
            {ex.formula_used && (
              <p className="mt-1 bg-[#DBEAFE] inline-block px-2 py-0.5">
                <LatexFormula code={ex.formula_used} block={false} />
              </p>
            )}
            {ex.steps?.length > 0 && (
              <ol className="mt-2 space-y-1 list-decimal list-inside marker:text-[#3B82F6] marker:font-mono">
                {ex.steps.map((s, j) => (
                  <li key={j}>{renderRich(s, regex)}</li>
                ))}
              </ol>
            )}
            {ex.answer && (
              <p className="mt-2 text-sm">
                <span className="font-mono text-[10px] uppercase tracking-widest text-[#3B82F6] mr-2">Answer</span>
                <span className="font-bold">{renderRich(ex.answer, regex)}</span>
              </p>
            )}
          </div>
        ))}
      </div>
    </Section>
  );
}
